module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "cont-top m-b-30 com-model flex flex-column align-initial flex-between"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("招聘中")]), _vm._v(" "), _c('el-tabs', {
    staticClass: "ac-tabs",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.acType),
      callback: function($$v) {
        _vm.acType = $$v
      },
      expression: "acType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "网络招聘会",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "线下招聘会",
      "name": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "ac-cont com-model"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, _vm._l((_vm.typeList[_vm.acType].list), function(item) {
    return _c('activity-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.typeList[_vm.acType].pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.typeList[_vm.acType].pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.typeList[_vm.acType].total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7552c04c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/jobfair.vue
// module id = 894
// module chunks = 1